export default __webpack_public_path__ + "static/media/gallery_03.523a3a47.jpg";